import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { EmpathySection } from '../components/sales/EmpathySection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { AudioSection } from '../components/sales/AudioSection';
import { BonusSection } from '../components/sales/BonusSection';
import { ClosingSection } from '../components/sales/ClosingSection';
import { OfferSection } from '../components/sales/OfferSection';
import { SalesNotifications } from '../components/ui/SalesNotifications';
// Extend window type for fbq
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
interface SalesPageProps {
  isLp1?: boolean;
}
export function SalesPage({
  isLp1
}: SalesPageProps) {
  useEffect(() => {
    // Inject Meta Pixel script
    if (!window.fbq) {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1703383767307378');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      // Noscript pixel fallback
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1703383767307378&ev=PageView&noscript=1" />`;
      document.head.appendChild(noscript);
    } else {
      window.fbq('track', 'PageView');
    }
  }, []);
  return <main className="min-h-screen bg-white" data-id="element-452">
      {/* <SalesNotifications /> */}
      <HeroSection data-id="element-453" />
      <AudioSection data-id="element-454" />
      <EmpathySection data-id="element-455" />
      <MechanismSection data-id="element-456" />
      <BenefitsSection data-id="element-457" />
      <BonusSection isLp1={isLp1} data-id="element-458" />
      <OfferSection isLp1={isLp1} data-id="element-459" />
      <ClosingSection data-id="element-460" />

      <footer className="bg-slate-50 py-12 border-t border-slate-200" data-id="element-461">
        <div className="container mx-auto px-4 text-center text-slate-500 text-sm" data-id="element-462">
          <p data-id="element-463">
            © {new Date().getFullYear()} Kit SOS Ansiedad. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-464">
            Este producto no reemplaza la terapia profesional. Si estás en
            crisis, llamá al 107 o acudí a una guardia.
          </p>
        </div>
      </footer>
    </main>;
}